import React from "react";

function Privacy() {
  return (
    <section
      className="bg-default text-light services-section"
      id="privacy-policy"
    >
      <div className="container">
        {/* Page Header */}
        <div className="mb-5 text-center">
          <h1 className="text-accent-2 mb-3 fw-bold">Privacy Policy</h1>
          <p className="fst-italic">Effective date: 24/06/2025</p>
          <p className="lead">
            Your privacy is critically important to us. This Privacy Policy
            applies to ChatCGT LTD (“we”, “us”, “our”) – registered at 250
            Humberstone Road, Leicester LE5 1BP – and governs data collection,
            processing, and storage for all visitors to{" "}
            <a
              href="https://chatcgt.co.uk"
              className="text-accent text-decoration-underline"
            >
              www.chatcgt.co.uk
            </a>
            .
          </p>
        </div>

        {/* Content Rows */}
        <div className="row gy-5">
          {/* 1. Information We Collect */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">1. Information We Collect</h2>
            <p>We collect two types of information:</p>
            <ul>
              <li>
                <strong>Information you provide:</strong> name, email,
                telephone, postal address, payment details (if submitted), and
                any data you enter via our Typeform (e.g. CGT details).
              </li>
              <li>
                <strong>Automatically collected data:</strong> analytics,
                cookies, and log data (IP address, browser type, pages viewed,
                timestamps).
              </li>
            </ul>
          </div>

          {/* 2. How We Use Your Data */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">2. How We Use Your Data</h2>
            <p>We process your personal data to:</p>
            <ul>
              <li>Calculate your Capital Gains Tax accurately.</li>
              <li>Deliver and improve our CGT calculation service.</li>
              <li>Communicate with you regarding your submission.</li>
              <li>Perform analytics and site-improvement activities.</li>
              <li>Comply with legal and regulatory obligations.</li>
            </ul>
          </div>

          {/* 3. Legal Basis for Processing */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">
              3. Legal Basis for Processing
            </h2>
            <ul>
              <li>
                <strong>Contractual necessity:</strong> processing is necessary
                to perform the CGT calculation service you request.
              </li>
              <li>
                <strong>Consent:</strong> for optional analytics cookies and
                marketing communications.
              </li>
              <li>
                <strong>Legitimate interests:</strong> ensuring site security,
                preventing fraud, and improving our service.
              </li>
              <li>
                <strong>Legal compliance:</strong> to satisfy our record-keeping
                obligations under UK law.
              </li>
            </ul>
          </div>

          {/* 4. Cookies & Tracking */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">4. Cookies & Tracking</h2>
            <p>
              We use cookies to remember your preferences, secure our site, and
              collect analytics via Google Analytics. You may manage your
              consent via our banner or your browser settings.
            </p>
          </div>

          {/* 5. Third-Party Services */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">5. Third-Party Services</h2>
            <p>
              We share data with:
              <ul>
                <li>
                  <strong>Typeform</strong> (form hosting & data collection).
                </li>
                <li>
                  <strong>Google Analytics</strong> (anonymous usage analytics).
                </li>
              </ul>
              All third parties operate under UK-GDPR compliant terms.
            </p>
          </div>

          {/* 6. International Transfers */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">
              6. International Transfers
            </h2>
            <p>
              Your data may be stored or processed outside the UK/EU by our
              providers. We ensure adequate safeguards (standard contractual
              clauses) are in place.
            </p>
          </div>

          {/* 7. Data Retention */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">7. Data Retention</h2>
            <p>
              We retain your personal data only as long as needed to fulfill
              the purposes above, plus any statutory record-keeping period (up
              to 6 years).
            </p>
          </div>

          {/* 8. Your Rights */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">8. Your Rights</h2>
            <p>
              Under the GDPR you have rights to:
              <ul>
                <li>Access, correct, or delete your data.</li>
                <li>Restrict or object to processing.</li>
                <li>Data portability.</li>
                <li>Withdraw consent at any time.</li>
                <li>Lodge a complaint with the UK Information Commissioner’s Office.</li>
              </ul>
              To exercise any right, please email us at{" "}
              <a
                href="mailto:info@chatcgt.co.uk"
                className="text-accent text-decoration-underline"
              >
                info@chatcgt.co.uk
              </a>
              .
            </p>
          </div>

          {/* 9. Children’s Privacy */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">9. Children’s Privacy</h2>
            <p>
              We do not knowingly collect personal data from anyone under 13.
              If you believe we have, please contact us to request deletion.
            </p>
          </div>

          {/* 10. Changes to This Policy */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">10. Changes to This Policy</h2>
            <p>
              We may update this policy to reflect changes in our practices or
              legal requirements. We’ll post updates here with a new effective
              date.
            </p>
          </div>

          {/* 11. Contact Us */}
          <div className="col-12">
            <h2 className="text-accent-2 mb-3">11. Contact Us</h2>
            <p>
              Contact details would be provided if and when needed after the form submission and on successful appointment of our services.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Privacy;
